import { render, staticRenderFns } from "./MdTextarea.vue?vue&type=template&id=5a5e30ab&scoped=true&"
import script from "./MdTextarea.vue?vue&type=script&lang=js&"
export * from "./MdTextarea.vue?vue&type=script&lang=js&"
import style0 from "./MdTextarea.vue?vue&type=style&index=0&id=5a5e30ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5e30ab",
  null
  
)

export default component.exports